// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"fdd83ff7","453":"eca70a73"}[chunkId] + ".chunk.js";
};